module.exports = __webpack_public_path__ + "img/tmslg-currency-guide-3.0933112f.png";